<hr class="upperline" />

<div class="my-account-form-container terra-error-style">
  <form [formGroup]="pageForm" (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()">
    <div class="form-grid">
      <!-- First Name -->
      <div class="terra-form-field-wrapper">
        <label for="txtFirstName" class="text-input-label">First & Middle name</label>
        <mat-form-field appearance="outline">
          <input matInput id="txtFirstName" formControlName="firstName" autocomplete="first-name" class="lo_sensitive" />
          <mat-error *ngIf="pageForm.get('firstName').hasError('required')"> Required </mat-error>
        </mat-form-field>
      </div>

      <!-- Last Name -->
      <div class="terra-form-field-wrapper">
        <label for="txtLastName" class="text-input-label">Last name</label>
        <mat-form-field appearance="outline">
          <input matInput id="txtLastName" formControlName="lastName" autocomplete="last-name" class="lo_sensitive" />
          <mat-error *ngIf="pageForm.get('lastName').hasError('required')"> Required </mat-error>
        </mat-form-field>
      </div>

      <!-- Phone number -->
      <terra-phone formControlName="phone1">
        <label for="txtPhone" class="text-input-label">Phone</label>
        <mat-error *ngIf="pageForm.get('phone1').hasError('required')">Required</mat-error>
      </terra-phone>

      <ng-container *ngIf="!clientDetails.organizationDetails">
        <!-- Country -->
        <div class="terra-form-field-wrapper">
          <label for="aucCountryId" class="text-input-label">Country of residence</label>
          <terra-country-auto-complete
            inputId="aucCountryId"
            controlName="countryId"
            placeholderText="Select country"
            [countriesList]="allCountries"
            >
          </terra-country-auto-complete>
        </div>
        <!-- State -->
        <div class="terra-form-field-wrapper" *ngIf="pageForm.get('countryId').value === USCountryId">
          <label for="ddlStateName" class="text-input-label">State</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="stateName" id="ddlStateName" placeholder="Select">
              <mat-option *ngFor="let stateOption of allStates" [value]="stateOption.name"> {{ stateOption.name }} </mat-option>
            </mat-select>
            <mat-error *ngIf="pageForm.get('stateName').hasError('required')"> Required </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Error message -->
      <div *ngIf="isSubmitted" class="full-width">
        <p *ngIf="pageForm.invalid" class="error-message">
          Please review and correct the fields marked in red
        </p>
        <p *ngIf="isGeneralServerError" class="error-message">{{ generalServerErrorMessage }}</p>
      </div>

      <div class="form-actions full-width" *ngIf="!clientDetails.isClientKYCApproved">
        <button type="submit" class="page-cta half-width tall-button" color="accent" mat-flat-button [disabled]="formSubmitting">Save</button>
      </div>
    </div>
  </form>
</div>
